import { getUrlParams } from './utils'
import { setSortOption } from './actions/searchActions';
import { fetchSortOptionsService } from './apiCalls';

import store from './store'



const filterByLowerPrice = () => {
    fetchSortOptionsService().then((response) => {
        const sortOptions = response.sort_options
        const lowerPriceSlug = sortOptions[1].name

        store.dispatch(setSortOption(lowerPriceSlug))
    })
}

const manageTags = (tags) => {
    if (tags.includes('mPrecoAds'))
        filterByLowerPrice()
}

const managePlansSorting = (sortOption) => {
    if (!window.location.pathname.includes('pesquisa'))
        return;

    store.dispatch(setSortOption(sortOption))
}


const manageParams = () => {
    const { tt, sortby } = getUrlParams();

    if (sortby)
        managePlansSorting(sortby)
    if (tt)
        manageTags(tt)
}

export default manageParams



// WEBPACK FOOTER //
// ./src/parameterManager.js